// @flow
import React from "react";
import { localize } from "redux-i18n";
import { Chart } from "@components";
import type { AbsenceStatistics } from "@modules/shared/reducer/employee-absences/types";

type Props = $Exact<{
  ...PropsFromLocalize,
  data: AbsenceStatistics,
}>;

export class AbsenceStatisticWeekday extends React.Component<Props> {
  get chartData() {
    return [
      [this.props.t("NUMBER_OF_DAYS"), this.props.t("SHORT_TERM"), this.props.t("LONG_TERM")],
      ...this.props.data.daysLostByWeekday.map(item => [
        item.description,
        item.value[0].value,
        item.value[1].value,
      ]),
    ];
  }

  render() {
    return (
      <Chart
        type="ColumnChart"
        title={this.props.t("TOTAL_DAYS_LOST_BY_WEEKDAY")}
        values={this.chartData}
        options={{ animation: false }}
      />
    );
  }
}

export default localize()(AbsenceStatisticWeekday);
